const richText = () => {
    const classes = {
        richTextHiddenContentVisible: 'rich-text__hidden-content--visible',
    };
    const selectors = {
        richTextSection: '[data-rich-text]',
        richTextReadMoreButton: '[data-rich-text-read-more-button]',
        richTextReadLessButton: '[data-rich-text-read-less-button]',
        richTextHiddenContent: '[data-rich-text-read-more-content]',
    };
    const richTextSections = document.querySelectorAll(selectors.richTextSection);
    richTextSections.forEach((section) => {
        const readMoreButton = section.querySelector(selectors.richTextReadMoreButton);
        const readLessButton = section.querySelector(selectors.richTextReadLessButton);
        const hiddenContent = section.querySelector(selectors.richTextHiddenContent);
        if (readMoreButton && hiddenContent) {
            readMoreButton.addEventListener('click', () => {
                hiddenContent.classList.add(classes.richTextHiddenContentVisible);
            });
        }
        if (readLessButton && hiddenContent) {
            readLessButton.addEventListener('click', () => {
                hiddenContent.classList.remove(classes.richTextHiddenContentVisible);
            });
        }
    });
};
export { richText };
